/**
 * Derive up to two uppercase initials from a display name.
 * Returns ".." as a neutral fallback when no name is available.
 * Ported from the original prototype's avatar logic.
 */
export function getInitials(label: string | null | undefined): string {
  if (!label) return "..";
  const initials = label
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word[0] ?? "")
    .slice(0, 2)
    .join("")
    .toUpperCase();
  return initials || "..";
}
